import type { FaireProductEntity } from "../../entity_types/product";

export const p_8mggyzxx4g: FaireProductEntity = {
  token: "p_8mggyzxx4g",
  type: "product",
  name: "Pink Mommy & Me Heart Print Knit Pullover Sweater",
  brandToken: "b_xvvfvktx6s",
  brandName: "Rylee Faith Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/e018f4826728492437476b51e2a4ea20024b72f66704ac0d1ec352b5ade08187.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/88803ac92f9c6571d61b2a361d21cc12ab875d1153c5d7b0af51e13f417414b2.jpeg",
    "https://cdn.faire.com/fastly/c094a97ac82c389b39f43d497a7bf91c7feb66f0e94d8c6e0ef027180720f8c4.jpeg",
    "https://cdn.faire.com/fastly/e58889e16c721340a37341e2cb3eafde4ae5bd7e111b7a88f03fa2bd2f74507d.jpeg",
    "https://cdn.faire.com/fastly/36d4af4433f9202457901cc180c9d5a2474f676e30895d840e7d4d5346c324c6.jpeg",
    "https://cdn.faire.com/fastly/222e240a0707cc8a56eff624f5a5d8be138357658dcf9324b4d72f158890a87c.jpeg",
    "https://cdn.faire.com/fastly/8dabd58fa932c0509beafb561e53999bc7a810ba518fb205867d0b5b34522a56.jpeg",
    "https://cdn.faire.com/fastly/fd8d67a0927ca1396b932eb26223fff95b5f8b5ece0db36ab8e017a142b2f95f.jpeg",
    "https://cdn.faire.com/fastly/5c4f8fc5fc1c7a9e59bff4176105e4262a9d5ac85ff7300d629739c5a5bc37c5.jpeg",
  ],
  priceDollars: 23.5,
  description:
    "Celebrate the special bond with this Pink Mom and Me Heart Print Knit Pullover Sweater. Its cozy knit fabric offers comfort for both mom and child, while the sweet heart pattern adds a charming touch. Perfect for matching moments and creating lasting memories, this sweater combines warmth and style effortlessly.\n\nkids:TPG51350\n\nadult:TPW50606\n\nMaterial:Viscose 60%,PBT 30%,Nylon 10%\n\n\n\n\n",
  tags: [],
  msrpDollars: 47,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:53.684Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
